<template>
    <div class="flex col">    
        <!-- <div class="unit_haeder">江西布袋自营核心产品</div> -->
        <div class="unit_text flex row">
            <div class="unit_text_list" v-for="item in list" :class="item.id==ids?'unit_text_list_active':''" :key="item.id" @click="addIds(item.id)">{{item.title}}</div>
        </div>
        <div class="unit_Box flex col">
            <img style="width:100%" v-lazy="ids==1?imgs1:imgs2" alt="" srcset="">
        </div>
    </div>
</template>
<script>
export default {
    name: "login",
    data(){
        return{
            list:[
                {id:1,title:'布袋胚芽米'},
                {id:2,title:'布袋“十零鸡蛋”'},
            ],
            ids:1,
            imgs1:'https://zlzbtest-1305103492.cos.ap-nanjing.myqcloud.com/imgFile/product_img/xiangqing.094edfa6.jpg',
            imgs2:'https://zlzbtest-1305103492.cos.ap-nanjing.myqcloud.com/imgFile/product_img/jidian.16e1777c.jpg',
        }
    },
    components: {
    },
    mounted(){

    },
    methods:{
       addIds(id){
           this.ids = id
       }
    }
}
</script>
<style scoped>
    body{
        background: #999999;
    }
     .unit_haeder{
        height: 1.28rem;
        background: #B22627;
        padding-bottom: 0.2rem;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
     }
    .unit_text{
        width: 100%;
        height: 1rem;
        border-bottom: 0.01rem solid #DDDDDD;
        padding-top: 0.4rem;
        box-sizing: border-box;
    }
    .unit_text_list{
        height: 0.6rem;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
        margin: 0 0.3rem;
    }
    .unit_text_list_active{
        color: #C11111;
        border-bottom: 0.01rem solid #C11111;
    }
    .unit_Box{
        width: 100%;
        height: calc(100vh - 1rem);
        overflow: auto;
        padding: 0.5rem 0.35rem;
        box-sizing: border-box;
    }
</style>